var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "schedule6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.97385 7.19504C1.56447 7.05841 1.56125 6.83796 1.98227 6.69744L16.9351 1.70681C17.3491 1.56862 17.5866 1.80067 17.4706 2.20722L15.6947 8.43076C14.9805 8.08608 14.1794 7.89289 13.3332 7.89289C12.8541 7.89289 12.3894 7.95482 11.9468 8.07111L14.5511 4.59434L8.28357 9.30098L1.97385 7.19504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6855 13.3334C17.6855 13.9341 17.5722 14.498 17.3455 15.0251C17.1188 15.5521 16.81 16.014 16.4189 16.4107C16.0279 16.8074 15.566 17.1191 15.0333 17.3458C14.5006 17.5725 13.9338 17.6858 13.3331 17.6858C12.7324 17.6858 12.1685 17.5725 11.6415 17.3458C11.1144 17.1191 10.6525 16.8102 10.2558 16.4192C9.85912 16.0282 9.54742 15.5663 9.32074 15.0336C9.09405 14.5009 8.9807 13.9341 8.9807 13.3334C8.9807 12.7327 9.09405 12.1688 9.32074 11.6418C9.54742 11.1147 9.85629 10.6528 10.2473 10.2561C10.6384 9.85941 11.1002 9.54772 11.633 9.32102C12.1657 9.09434 12.7324 8.98099 13.3331 8.98099C13.9338 8.98099 14.4977 9.09434 15.0248 9.32102C15.5518 9.54772 16.0137 9.85658 16.4104 10.2476C16.8071 10.6387 17.1188 11.1005 17.3455 11.6332C17.5722 12.166 17.6855 12.7327 17.6855 13.3334ZM13.333 13.3334V11.1572H12.2449V14.4215H14.9651V13.3334H13.333Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule6);
export default __webpack_public_path__ + "static/media/schedule6.ae3d7684ff0141fcfb5723897207171b.svg";
export { ForwardRef as ReactComponent };